import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface SignUpState {
  email: string | null;
}

const initialState: SignUpState = {
  email: null,
};

export const signUpSlice = createSlice({
  name: "signUp",
  initialState,
  reducers: {
    setEmail: (state, action: PayloadAction<string | null>) => {
      state.email = action.payload;
    },
  },
});

export const { setEmail } = signUpSlice.actions;

export default signUpSlice.reducer;
